export const service_package = {
  table: {
    field: {
      name: 'Nama',
      subscription_fee: 'Biaya berlangganan',
      contact_count: 'Kontak akun',
      contact_method_count: 'Methode kontak akun',
      ivr_count: 'IVR count',
      estimate: 'Estimate',
      record: 'Call recording',
      disk_space_mb: 'Disk space (MB)',
      sip_account_with_caller_id_count: 'Akun SIP untuk panggilan keluar'
    }
  },

  modal: {
    change: {
      content: 'Anda yakin untuk pelayanan paket {name} Virtual PBX?',
      buttons: {
        ok: 'Toggle'
      }
    },

    change_time: {
      title: 'Ganti paket PBX?',
      content: 'Anda dapat mengganti paket PBX atau berdasar waktu paket',
      buttons: {
        immediate: 'Ganti sekarang',
        deferred: 'Ganti saat {date}'
      }
    }
  },

  card: {
    cost: '{cost} per bulan',
    connect: 'Hubungan',
    connected: 'Terhubung',
    unlimited: 'Unlimited'
  },

  limit: {
    record: 'Catatan panggilan tidak tersedia untuk paket PBX Anda',
    contacts: 'Jumlah kontak maksimum telah dibuat untuk paket layanan PBX Anda',
    contact_methods:
      'Menambahkan jumlah metode kontak maksimum yang disediakan oleh paket PBX Anda',
    ivr: 'Jumlah IVR maksimum telah dibuat untuk paket PBX Anda'
  }
};
